export const environment = {
    production: true,
    collectJsonApiBaseUrl: 'https://collect.interno.pack.alterdata.com.br/api/v1',
    packupBaseUrl: 'https://packup-release2.interno.pack.alterdata.com.br',
    identificacaoUrl: 'https://identificacao-release-2.interno.pack.alterdata.com.br/api/v1',
    menuUrl: 'https://menu-econtador-release2.interno.pack.alterdata.com.br',
    ajudaMFAGetNet: 'https://ajuda.alterdata.com.br/cbc/collect-status-site-exigindo-acao-do-usuario-ao-buscar-dados-da-operadora-getnet',
    santanderGetNetUrl: 'https://minhaconta.getnet.com.br/login'
}


// WEBPACK FOOTER //
// ./src/environments/environment.ts